import React, { useEffect, useState } from "react";
import { Container, Spinner, Card, Button, Row } from "reactstrap";
import Header from "components/Headers/Header";
import { useDispatch, useSelector } from "react-redux";
import { getA4BSuggestions } from "store/actions/generalActions";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const suggestionColumns = ["User Name", "Email", "Role", "Suggestion"];

const suggestionKeyMap = {
  "User Name": "user_name",
  Email: "email",
  Role: "role",
  Suggestion: "suggestion",
};

const SuggestionBox = () => {
  let dispatch = useDispatch();

  const a4bInfoPoints = [
    "The Admin is responsible for reviewing suggestions submitted by: A4B fans,  A4B athletes.",
    "These suggestions pertain to the platform.",
    "The Admin should evaluate each suggestion.",
    "If the suggestion is valuable, the Admin must take appropriate action.",
  ];
  const a4bInfoTitle = "A4B Suggestion Box Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const {
    a4bSuggestions,
    lastDocA4bSuggestions,
    hasMoreA4bSuggestions,
    isFetchingA4bSuggestions,
  } = useSelector((state) => state.general);
  const [loader, setLoader] = useState({
    data: false,
  });

  const handleLoadMore = () => {
    if (hasMoreA4bSuggestions && !isFetchingA4bSuggestions) {
      dispatch(getA4BSuggestions(lastDocA4bSuggestions));
    }
  };

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getA4BSuggestions(null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  return (
    <>
      <Header />

      <Container fluid className="mb-5">
        <Row>
          {" "}
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Card className="p-2">
          {loader.data ? (
            <div className="text-center py-4">
              <Spinner size="lg" color="primary" />
            </div>
          ) : (
            <>
              <TableComponent
                columns={suggestionColumns}
                data={a4bSuggestions}
                keyMap={suggestionKeyMap}
              />
              {a4bSuggestions?.length > 4 && (
                <div className="text-center my-4">
                  <Button
                    onClick={handleLoadMore}
                    disabled={
                      isFetchingA4bSuggestions || !hasMoreA4bSuggestions
                    }
                    color="primary"
                  >
                    {isFetchingA4bSuggestions ? (
                      <Spinner size="sm" />
                    ) : (
                      "Load More"
                    )}
                  </Button>
                </div>
              )}
            </>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={a4bInfoPoints}
        title={a4bInfoTitle}
      />
    </>
  );
};

export default SuggestionBox;
